module.exports = __webpack_public_path__ + "img/ar.50bcaaec.svg";